import { Document } from '@contentful/rich-text-types'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { RichText } from '~/components/RichText'
import type { RichTextOptions } from '~/components/RichText/types'
import { PieChartIcon } from '~/components/icons'
import { TypeStatisticalInsights } from '~/types/contentful'

type StatisticalInsightProps = {
  statisticalInsight: TypeStatisticalInsights<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

const richTextOptions: RichTextOptions = {
  extraProps: {
    [BLOCKS.PARAGRAPH]: {},
  },
  renderNode: {
    [BLOCKS.OL_LIST]: (_, children) => (
      <ol className="list-none p-0 statistical-ol" style={{ counterReset: 'ol-counter' }}>
        {children}
      </ol>
    ),
    [BLOCKS.UL_LIST]: (_, children) => (
      <ul className="list-none pl-1 mb-0 [&>li]:mb-4 [&>li]:last:mb-0 [&>li]:before:content-none">
        {children}
      </ul>
    ),
    [BLOCKS.LIST_ITEM]: (_, children) => (
      <li className="relative pl-5 text-mobile-s [&>p]:text-inherit before:block before:absolute before:top-0 before:left-0 max-lg:[&>p]:text-[17px] max-md:pl-[18px] max-md:text-mobile-xs max-md:[&>p]:text-inherit">
        {children}
      </li>
    ),

    [INLINES.HYPERLINK]: (node, children) => (
      <a
        target="_blank"
        rel="noreferrer noopener"
        href={node.data.uri}
        className="text-neutral-60 hover:text-blue-60 underline"
      >
        {children}
      </a>
    ),
  },
}

export const StatisticalInsight = ({ statisticalInsight }: StatisticalInsightProps) => {
  const { fields } = statisticalInsight

  return (
    <div className="bg-indigo-10 flex flex-col my-12 gap-6 rounded-3xl pt-2 px-7 pb-9">
      <div className="border-indigo-20 border-b flex gap-2 items-center h-16">
        <PieChartIcon className="text-indigo-60" />

        <h4 className="text-indigo-60 text-xs !mt-0">Statistical Insight</h4>
      </div>
      <RichText
        doc={fields?.body as Document}
        options={richTextOptions}
        className="StatisticalInsight__RichText"
      />
    </div>
  )
}
